import{a as r}from"./ninox-components-H7U3JDMW.js";import{m as o}from"./ninox-components-2ADN25D5.js";import{k as e}from"./ninox-components-R4FVH3NU.js";import{a as i}from"./ninox-components-I2GBTDK4.js";import n,{css as l}from"styled-components";var f=n.label`
    position: relative;
    display: inline-flex;
    justify-content: center;
    box-sizing: border-box;
    line-height: ${19/13};

    color: ${({theme:t})=>t.text.label};

    ${({labelPosition:t})=>l`
        flex-direction: ${r(t)};
        align-items: ${t==="left"||t==="right"?"center":"start"};

        gap: ${t==="left"||t==="right"?o.x_small:o.xxx_small};
    `}

    &:active,
    &:has(:focus-visible),
    &:focus-within:hover {
        color: ${({theme:t})=>t.text.primary};
    }

    font-family: inherit;
    font-size: ${e.x_small};
    font-weight: ${i.semibold};
    text-wrap: balance;

    transition-property: color;
    transition-timing-function: ease;
    transition-duration: 150ms;
`,m=n.section`
    display: inline-flex;
    flex-flow: column;
    align-items: start;
    justify-content: start;
    gap: ${o.xxx_small};

    color: ${({theme:t})=>t.text.primary};

    font-size: ${e.large};
    font-weight: ${i.semibold};
    text-wrap: balance;
`,x=n.aside`
    color: ${({theme:t})=>t.text.secondary};

    font-size: ${e.medium};
    font-weight: ${i.normal};
    text-wrap: pretty;
`;export{f as a,m as b,x as c};
//# sourceMappingURL=ninox-components-ILT2UNSC.js.map